import React from "react";
import Header from "./Header";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const OutletComponent = () => {
  console.log("otlet");

  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <Header />
      <Outlet />
    </Box>
  );
};

export default OutletComponent;
